import { useUpdateNeoletterUserProfileMutation } from "shared/api/neoletter-user-profile/mutation.generated"
import { useNeoletterUserProfileLazyQuery } from "shared/api/neoletter-user-profile/queries.generated"
import { useEvent } from "shared/lib/useEvent"
import { ApolloFetchPolicy } from "shared/types/ApolloFetchPolicy"
import { NeoletterUserProfile } from "shared/types/__generated__/graphql"

import { useNeoletterUserProfileCache } from "./useNeoletterUserProfileCache"

export function useUpdateNeoletterUserProfile() {
  const [mutate, rest] = useUpdateNeoletterUserProfileMutation()
  const { updateCustomFieldsCache } = useNeoletterUserProfileCache()
  const [refetchProfile] = useNeoletterUserProfileLazyQuery({
    fetchPolicy: ApolloFetchPolicy.NETWORK_ONLY
  })

  const handleUpdateProfile = useEvent(
    ({
      customFields
    }: {
      customFields: Partial<NeoletterUserProfile["custom_fields"]>
    }) => {
      updateCustomFieldsCache(customFields)
      return mutate({
        variables: {
          input: { custom_fields: customFields }
        },
        onCompleted: () => {
          refetchProfile()
        },
        onError: () => {
          refetchProfile()
        }
      })
    }
  )

  return {
    updateProfile: handleUpdateProfile,
    ...rest
  }
}
